<template>
  <div class="row items-center no-wrap tw-gap-1">
    <q-btn
      data-testid="agente-despausar"
      no-caps
      unelevated
      v-if="isPaused"
      @click="setUnpause"
      class="col tw-rounded-lg"
      padding="4px 0"
      color="red"
      text-color="white"
    >
      <UnpauseMiniIcon />
      <span class="q-pl-sm text-label text-bold">Despausar</span>
    </q-btn>

    <q-btn
      data-testid="agente-cancelar-pausa"
      no-caps
      unelevated
      class="col tw-rounded-lg"
      padding="4px 0"
      v-else-if="hasSchedulePause"
      @click="clearSchedulePause"
      color="orange-9"
      text-color="white"
    >
      <span class="text-label text-bold">Não Pausar</span>
      <q-tooltip>Pausa será aplicada após o atendimento finalizar! Clique aqui para cancelar essa ação.</q-tooltip>
    </q-btn>

    <q-btn
      data-testid="agente-pausar"
      v-else
      no-caps
      unelevated
      class="col tw-rounded-lg tw-border tw-border-solid tw-border-black/10 tw-transition hover:tw-bg-greyc-1"
      padding="4px 0"
      color="white"
      text-color="grey-8"
    >
      <q-menu max-width="280px">
        <q-list dense>
          <template v-for="reason in pauseReasons">
            <q-item
              :data-testid="`pausa-${reason.id}`"
              dense
              clickable
              v-close-popup
              :key="reason.id"
              @click="setPause(reason.id)"
            >
              <q-item-section class="[overflow-wrap:anywhere]">
                {{ reason.description }}
              </q-item-section>
            </q-item>

            <q-separator :key="`separator-${reason.id}`" />
          </template>
        </q-list>
      </q-menu>

      <PauseMiniIcon class="q-mr-sm" />
      <span class="text-label">Pausar</span>
    </q-btn>

    <div class="col-auto">
      <q-btn
        data-testid="agente-dnd"
        size="sm"
        unelevated
        padding="4px"
        class="tw-rounded-full tw-transition hover:tw-bg-greyc-4"
        :icon="autoRejection ? 'mdi-bell-cancel' : 'mdi-bell-check'"
        :text-color="isDNDLocked ? 'grey-8' : (autoRejection ? 'red-8' : 'green-8')"
        @click="setAutoRejection(!autoRejection)"
        :disable="isDNDLocked"
        v-if="useDND"
      >
        <q-tooltip><span class="text-bold">{{ dndTooltip }}</span></q-tooltip>
      </q-btn>
      <span v-else>&nbsp;</span>
    </div>

    <q-btn
      data-testid="agente-cancelar-deslogar"
      v-if="hasScheduleLogout"
      no-caps
      unelevated
      class="col tw-rounded-lg"
      padding="4px 0"
      color="orange-9"
      text-color="white"
      @click="clearScheduleLogout"
    >
      <span class="text-label text-bold">Não Deslogar</span>
      <q-tooltip>Deslogar será aplicado após o atendimento finalizar! Clique aqui para cancelar essa ação.</q-tooltip>
    </q-btn>

    <q-btn
      data-testid="agente-deslogar"
      v-else
      no-caps
      unelevated
      class="col tw-rounded-lg tw-border tw-border-solid tw-border-black/10 tw-transition hover:tw-bg-greyc-1"
      padding="4px 0"
      color="white"
      text-color="grey-8"
      @click="logout"
    >
      <LogoutMiniIcon class="q-mr-sm" />
      <span class="text-label">Deslogar</span>
    </q-btn>
  </div>
</template>

<script>
import PauseMiniIcon from '@/assets/icons/pauseMini.svg'
import LogoutMiniIcon from '@/assets/icons/logoutMini.svg'
import UnpauseMiniIcon from '@/assets/icons/unpauseMini.svg'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  components: {
    PauseMiniIcon,
    LogoutMiniIcon,
    UnpauseMiniIcon
  },

  computed: {
    ...mapState({
      isPaused: ({ agentModule }) => Boolean(agentModule?.session?.agent?.paused),
      inAttendance: ({ agentModule }) => Boolean(agentModule?.session?.agent?.inAttendance),
      pauseReasons: ({ agentModule }) => agentModule.session.pauseReasons,
      autoRejection: ({ agentModule }) => Boolean(agentModule?.autoRejection),
      hasSchedulePause: ({ agentModule }) => Boolean(agentModule.session.schedulePause),
      hasScheduleLogout: ({ agentModule }) => Boolean(agentModule.session.scheduleLogout),
      hasJourneyPrePause: ({ agentModule }) => Boolean(agentModule.journeyPrePause)
    }),

    ...mapGetters({
      useDND: 'settingsModule/useDND'
    }),

    isDNDLocked () {
      return this.hasScheduleLogout || this.hasSchedulePause || this.isPaused || this.hasJourneyPrePause
    },

    dndTooltip () {
      if (this.hasJourneyPrePause) return '"Não perturbe" não pode ser removido durante a contagem para pausa programada'
      return this.autoRejection ? '"Não perturbe" ativado' : '"Não perturbe" desativado'
    }
  },

  methods: {
    ...mapActions({
      logout: 'sipModule/logout',
      pause: 'sipModule/pause',
      unpause: 'sipModule/unpause',
      init: 'socketModule/init',
      setAutoRejection: 'agentModule/setAutoRejection',
      clearSchedulePause: 'agentModule/clearSchedulePause',
      clearScheduleLogout: 'agentModule/clearScheduleLogout'
    }),

    setPause (pauseReasonId) {
      this.pause(pauseReasonId)
    },

    setUnpause () {
      this.unpause()
      this.init()
    }
  }
}
</script>

<style lang="sass" scoped>
.text-label
  font-style: normal
  font-weight: normal
  font-size: 13px
  line-height: 15px

.text-label.text-bold
  font-weight: bold !important

.text-bold
  font-weight: bold !important
</style>
